<template>
  <div>
    <sinvoice-export-by-group />
  </div>
</template>

<script>
import SinvoiceExportByGroup from '@/components/sinvoice_viettel/SinvoiceExportByGroup.vue'

export default {
  name: 'ExportByGroupView',
  components: { SinvoiceExportByGroup }
}
</script>

<style scoped>
h2 { margin: 10px 0; }
</style>

